<script>
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import Layout from '@layouts/main'

import {AxiosHelper} from '@src/utils/utils';
import Datatable from '@components/Datatable';
// import Modal from '@components/Modal';
import moment from 'moment';

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid';
import allLocales from '@fullcalendar/core/locales-all';
import momentPlugin from '@fullcalendar/moment';
import interactionPlugin from '@fullcalendar/interaction';
import ManualRegistPopup from './manual_regist_popup';
import DetailRegistPopup from './detail_regist_popup';
import PayChart from './pay_chart';
import {simpleComputed} from "@state/helpers";


export default {
	components: { Layout, FullCalendar, Datatable, ManualRegistPopup, DetailRegistPopup, PayChart },
  data() {
    return {
			calendarPlugins: [ dayGridPlugin, timeGridPlugin, momentPlugin, interactionPlugin ],
			locales : allLocales,
			header : {
				left:   'prev,next today',
				center: 'title',
				right: 'manualRegistBtn chartBtn'
			},
			customButtons : {
				manualRegistBtn: {
					text: '수기결제입력',
					click: () => {this.dateClick()}
				},
				chartBtn: {
					text: '차트보기',
					click: () => { this.$refs.payChart.show() }
				}
			},
	    viewMode: null,

			cardInfos : {},
			categoryColors : [],
			baseDate : {
				prevStart : '',
				prevEnd : '',
				baseStart : '',
				baseEnd: ''
			},

			intervalPayList : [],
			events : [],
			totalSummary : 0,
			guessTotalSummary : 0,
			detailDatatables : [],
			activeIndex : 0,
			detailTime : 0,
			detailRegistOpen : false,
			manualRegistOpen : false,
			manualRegistTime : 0,
			chartOpen : false,

			tableOption : {
				searching : false,
				columns : [
					{data : 'ymd'},
					{data : 'price'},
					{data : 'orgMsg'}
				]
			},
    }
	},

	beforeCreate() {
		// 카드정보
		const p1 = AxiosHelper.get('/api/cardsms/cardInfo/list').then(ret => {
			const cardInfos = {};
			ret.data.forEach(item => {
				cardInfos[item.phone] = {
					name : item.card_name,
					phone : item.phone,
					price : 0,
					details : []
				};
			});

			this.cardInfos = cardInfos;
		});

		// 지출카테고리
		const p2 = AxiosHelper.get('/api/cardsms/group/kind').then(ret => {
			this.categoryColors = ret.data;
		});

		Promise.all([p1, p2]).then(() => {
		});
	},
	mounted() {
		// console.log('this.isWideMode', this.isWideMode)
		this.viewMode = this.isWideMode ? 'dayGridMonth' : 'dayGridDay'
	},

	watch: {
		isWideMode(n) {
			this.viewMode = this.isWideMode ? 'dayGridMonth' : 'dayGridDay'
		}
	},
	computed: {
		...simpleComputed
	},
	methods : {
		eventsHandler(info, successCallback, failCallback) {
			this.baseDate.start = info.start.getTime();
			this.baseDate.end = info.end.getTime();
			this.baseDate.midTime = this.baseDate.start + ((this.baseDate.end - this.baseDate.start) / 2);
			
			this.baseDate.thisMonth = moment(this.baseDate.midTime);
			this.baseDate.baseStart = this.baseDate.thisMonth.startOf('month').format('x');
			this.baseDate.baseEnd = this.baseDate.thisMonth.endOf('month').format('x');
			this.baseDate.prevMonth = moment(this.baseDate.start - 1000 * 60 * 60 * 24);
			this.baseDate.prevStart = this.baseDate.prevMonth.startOf('month').format('x');
			this.baseDate.prevEnd = this.baseDate.prevMonth.endOf('month').format('x');

			for(const key in this.cardInfos) {
				this.cardInfos[key].details = [];
				this.cardInfos[key].price = 0;
			}
			this.intervalPayList = [];
			this.totalSummary = 0;
			this.guessTotalSummary = 0;
			this.detailDatatables = [];

			const p1 = this.makeCalendarEvent();
			const p2 = this.intervalPayCheck();
			

			Promise.all([p1, p2]).then(([{events, intervalPayList}, intervalPayList2]) => {
				let sum = 0;

				for(const item of intervalPayList) {
					for(let j = 0; j < intervalPayList2.length; j++) {
						const pastPay = intervalPayList2[j];
						if(pastPay.ruleName === item.ruleName) {
							intervalPayList2.splice(j, 1);
							break;
						}
					}
				}
				
				intervalPayList2.forEach((val) => {
					sum += val.willPayPrice;
				})


				successCallback(events);

				this.intervalPayList = intervalPayList2;
				this.guessTotalSummary = sum;
				this.activeIndex = 0;
			});
		},

		getEventColor(item) {
			let eventTextColor = '#FFFFFF';
			let eventColor = '#B7B7B7';	// 이전월, 다음월 색상
			let eventBorderColor = '#cccccc';

			if(this.baseDate.baseStart <= item.time && item.time < this.baseDate.baseEnd) {
				if(item.detailCnt > 1) {
					eventTextColor = '#FFFFFF';
					eventColor = this.categoryColors[0].color;	// 내역등록된거, 다건으로 등록된건 생활비로 본다
					eventBorderColor = '#FFFFFF';	// 내역등록된거
				}
				else if(item.detailCnt === 1) {
					eventTextColor = '#FFFFFF';
					eventColor = this.categoryColors[item.category].color;	// 내역등록된거
					eventBorderColor = '#FFFFFF';	// 내역등록된거
				}
				else {
					eventTextColor = '#000000';
					eventColor = '#FFFFFF';	// 현재월
					eventBorderColor = '#4B80F9';	// 현재월
				}
			}

			return {eventTextColor, eventColor, eventBorderColor};
		},

		intervalPayCheck() {
			return new Promise((resolve, reject) => {
				if(moment().format('YYYYMM') !== moment(this.baseDate.midTime).format('YYYYMM')) {
					// this.intervalPayList.splice(0);
					resolve([]);
					return;
				}

				AxiosHelper.get(`/api/cardsms/pay/history/${this.baseDate.prevStart}/${this.baseDate.prevEnd}/fixed`).then(ret => {
					const intervalPayRule = this.getDefaultPayRule(this.baseDate.midTime);
					const intervalPayList = [];
		
					/*
					전월 전체 결제내역에서 ruleList에 해당하는 항목만 추려낸다
					*/
					for(const item of ret.data) {
						const obj = {
							willPayName : item.detail_name,
							willPayPrice : item.price.toInt(),
							condition : `${item.orgMsg} ${item.detail_name}`
						};
		
						for(let j = 0; j < intervalPayRule.length; j++) {
							const rule = intervalPayRule[j];
							if(obj.condition.search(rule.rule) !== -1) {	// finded
								obj.ruleName = rule.willPayName;
								intervalPayRule.splice(j, 1);
								intervalPayList.push(obj);
								break;
							}
						}
					}
		
					resolve(intervalPayList);
				});

			});
		},
		
		getDefaultPayRule(baseTime) {
			const ruleList = [
				{willPayName : '도시가스', rule : /(도시가스|예스코)/g},
				{willPayName : '전기세', rule : /(전기세|한전|한국전력)/g},
				{willPayName : '인터넷', rule : /(LG U\+)/g},
				{willPayName : '내 핸드폰', rule : /(KT통신요금)/g},
				{willPayName : '비데2', rule : /(14900)[\w\W]+(대림비앤코)/g},
			];
			
			if(moment(baseTime).format('MM').toInt() % 2 === 0) {	// 짝수달
				ruleList.push({
					willPayName : '수도세', rule : /(수도)/g
				});
			}

			return ruleList;
		},
		
		makeCalendarEvent() {
			return new Promise((resolve, reject) => {
				AxiosHelper.get(`/api/cardsms/pay/history/${this.baseDate.baseStart}/${this.baseDate.baseEnd}`).then(ret => {
					const events = [];
					const intervalPayRule = this.getDefaultPayRule(this.baseDate.midTime);
					const intervalPayList = [];
		
					for(let item of ret.data) {
						const {eventTextColor, eventColor, eventBorderColor} = this.getEventColor(item);
						events.push({
							id : item.time,
							title : `${item.card_name} ${item.price.toComma()}원`,
							start : item.time,
							end : item.time + (60 * 1000),
							backgroundColor : eventColor,
							borderColor : eventBorderColor,
							textColor : eventTextColor
						});
		
						// 정확하게 이번달 사이 기간만 금액 합산
						if(this.baseDate.baseStart <= item.time && item.time < this.baseDate.baseEnd) {
							this.cardInfos[item.phone].price += item.price.toInt();
							this.cardInfos[item.phone].details.push(item);
							this.totalSummary += item.price.toInt();
						}

						const obj = {
							willPayName : item.detail_name,
							willPayPrice : item.price.toInt(),
							condition : `${item.orgMsg} ${item.detail_name}`
						};
		
						for(let j = 0; j < intervalPayRule.length; j++) {
							const rule = intervalPayRule[j];
							if(obj.condition.search(rule.rule) !== -1) {	// finded
								obj.ruleName = rule.willPayName;
								intervalPayRule.splice(j, 1);
								intervalPayList.push(obj);
								break;
							}
						}
					}
					
					resolve({events, intervalPayList});
				});
				
			});
		},

		eventClick(info) {
			info.jsEvent.stopPropagation();
			info.jsEvent.preventDefault();
			
			const orgTime = info.event.start.getTime();
			this.$refs.detailRegistPopup.show(orgTime);
			// this.toggleDetailRegist(null, orgTime);
		},

		closeDetailRegist(action) {
			this.eventAction(action);
		},

		dateClick(info) {
			this.$refs.manualRegistPopup.show(info ? info.date.getTime() : new Date().getTime());
		},

		closeManualRegist(action) {
			this.eventAction(action);
		},
		
		tabClickHandler(event) {
			event.stopPropagation();
			event.preventDefault();
			
			const idx = event.target.dataset.index.toInt();

			this.activeIndex = idx;
		},

		eventAction(action) {
			if(!action) {
				return;
			}

			let calendarApi = this.$refs.calendarRef.getApi();
			
			if(action.action === 'removed') {	// 이벤트 항목 삭제
				calendarApi.getEventById(action.time).remove();
			}
			else if(action.action === 'saved') {	// 이벤트 상세 내용 저장
				var item = {
					detailCnt : action.detailCnt,
					category : action.category,
					time : action.time
				};
				
				const event = calendarApi.getEventById(item.time);
				const {eventTextColor, eventColor, eventBorderColor} = this.getEventColor(item);
				event.setProp('backgroundColor', eventColor);
				event.setProp('borderColor', eventBorderColor);
				event.setProp('textColor', eventTextColor);
			}
			else if(action.action === 'added') {
				var time = moment(new Date(action.dt + ':00')).format('x');

				var event = {
					title : action.card_name + ' ' + action.price.toComma() + '원',
					id : time,
					time : time,
					start : time,
					end : time + (60 * 1000),
					allDay : false
				};
				const {eventTextColor, eventColor, eventBorderColor} = this.getEventColor(event);
				event.backgroundColor = eventColor;
				event.borderColor = eventBorderColor;
				event.textColor = eventTextColor;

				
				calendarApi.addEvent(event);
				calendarApi.next();
				calendarApi.prev();
			}
		}, 


	}
}
</script>

<template>
  <Layout>
    <C.PageHeader title="월간상세" />

		<C.Row>
			<C.Col lg="12">
				<C.Card>
					<C.CardHeader>
						카드별 사용금액
					</C.CardHeader>
					<C.CardBody>
						<ul class="nav nav-tabs nav-bordered" @click="tabClickHandler">
							<li class="nav-item">
								<a href="#tab_0" data-index="0" data-toggle="tab" aria-expanded="false" 
									class='nav-link'
									:class="{ active: activeIndex === 0 }">
									전체
								</a>
							</li>
							<li v-for="([phone, card], idx) in Object.entries(cardInfos)" v-show="card.price > 0" :key="card.phone" class="nav-item">
								<a :href="'#tab_' + (idx + 1)" :data-index="idx + 1" data-toggle="tab" aria-expanded="false" 
									class='nav-link'
									:class="{ active: activeIndex === (idx + 1) }">
									{{card.name}} : {{card.price.toComma()}}원
								</a>
							</li>
						</ul>

						<div class="tab-content">
							<div id="tab_0" class='tab-pane'
								:class="{ show: activeIndex === 0, active: activeIndex === 0 }">
								<p>전체 사용금액 : {{totalSummary.toComma()}}원
								&nbsp;&nbsp;&nbsp;
								결제예정금액 합산추정 : {{(totalSummary + guessTotalSummary).toComma()}}원</p>
								<p v-for="willPay in intervalPayList" :key="willPay.willPayName">{{willPay.willPayName}}  {{willPay.willPayPrice.toComma()}}원 결제 예정</p>
							</div>
							<div v-for="([phone, card], idx) in Object.entries(cardInfos)" v-show="card.price > 0" :id="'tab_' + (idx + 1)" :key="idx" 
								class='tab-pane'
								:class="{ show: activeIndex === (idx + 1), active: activeIndex === (idx + 1) }">
								<Datatable 
									:option="tableOption"
									:data="card.details"
									table-remove-classes="table-sm"
									table-add-classes="table-xs"
								/>
							</div>
						</div>
					</C.CardBody>
				</C.Card>
			</C.Col>
		</C.Row>

		<C.Row>
			<C.Col lg="12">
				<C.Card>
					<C.CardHeader>
						구글 메일을 통해 가져온 월별 결제 내역, 또는 수기 입력
					</C.CardHeader>	
					<C.CardBody>
						<ul style="width:100%; paddingLeft:0">
							<li v-for="color in categoryColors" :key="color.color" :style="{ backgroundColor: color.color }" style="width:30px; height:10px; color:#FFFFFF; display:inline; margin-right:10px; padding:0 10px">{{color.cate_name}}</li>
						</ul>
						<FullCalendar
								v-if="viewMode"
							ref="calendarRef"
							:default-view="viewMode"
							:plugins="calendarPlugins" 
							:header="header"
							:locales="locales"
							locale="ko"
							event-time-format='HH:mm'
							:events="eventsHandler"
							:custom-buttons="customButtons"
							@eventClick="eventClick"
							@dateClick="dateClick"
						/>
					</C.CardBody>
				</C.Card>
			</C.Col>
		</C.Row>
		<DetailRegistPopup ref="detailRegistPopup"
			@hidden="closeDetailRegist"/>
		<ManualRegistPopup ref="manualRegistPopup"
			@hidden="closeManualRegist"
		/>
		<PayChart ref="payChart"
			:prev-start-time="baseDate.prevStart"
			:prev-end-time="baseDate.prevEnd"
			:start-time="baseDate.baseStart"
			:end-time="baseDate.baseEnd"
		/>
  </Layout>
</template>